import { Component } from '@verndale/core';
import tippy from 'tippy.js';
import serialize from 'form-serialize';
import MicroModal from 'micromodal';
import axios from 'axios';
import Pristine from 'pristinejs';

import {
  SERIALIZE_SETTINGS,
  PRISTINE_SETTINGS
} from '../utils/default-settings';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $el: this.el,
      $modalCoo: this.el._$('.modal-certificate-analysis__coo'),
      $modalCooForm: this.el._$('.modal-certificate-analysis__coo form'),
      $modalCooBtnSubmit: this.el._$(
        '.modal-certificate-analysis__form button[type="submit"]'
      ),
      $modalCooRequest: this.el._$('.modal-certificate-analysis__coo-request'),
      $modalCooRequestForm: this.el._$(
        '.modal-certificate-analysis__coo-request form'
      ),
      $modalCooRequestFormLotNumber: this.el._$(
        '.modal-certificate-analysis__coo-request form [name="lot_number"]'
      ),
      $modalCooRequestBtnSubmit: this.el._$(
        '.modal-certificate-analysis__coo-request button[type="submit"]'
      ),
      $coaRequestCatalogNumber: this.el._$(
        '.modal-certificate-analysis__coo-request [name=atcc_catalog_number]'
      ),
      $modalMessage: this.el._$('.modal-certificate-analysis__error-message'),
      $modalSuccess: this.el._$('.modal-certificate-analysis__success'),
      $recaptcha: this.el._$('.g-recaptcha'),
      $requiredFields: this.el._$$('.modal-certificate-analysis__form [data-required="true"]'),
      $coaContainer: this.el._$('.certificate-of-analysis__download'),
      $coaForm: this.el._$('.certificate-of-analysis__form'),
      $coaBtnSubmit: this.el._$(
        '.certificate-of-analysis__form .certificate-of-analysis__submit'
      ),
      $coaItemNumber: this.el._$(
        '.certificate-of-analysis__form [name=atcc_number]'
      ),
      $coaItemNumberAutocomplete: this.el._$(
        '.certificate-of-analysis__form .certificate-of-analysis__input-autocomplete'
      ),
      $coaItemNumberAutocompleteList: this.el._$(
        '.certificate-of-analysis__form .certificate-of-analysis__input-autocomplete-list'
      )
    };
    this.modalId = 'modal-certificate-analysis';
    this.tooltipTriggerClass = '.modal-certificate-analysis__tooltip';
    this.pristineCoa = null;
    this.pristineCoo = null;
    this.pristineCooRequest = null;

    this.init();
    this.modalInit();
    this.pristineInit();
    this.tooltipInit();
  } //setupDefaults

  addListeners() {
    const { $coaItemNumber, $modalCoo, $modalCooRequest, $modalCooRequestBtnSubmit, $coaBtnSubmit } = this.dom;

    // $coaForm?._on('submit', this.submitCoo.bind(this));
    $coaItemNumber?._on('keyup', this.setAutocomplete.bind(this));
    $coaItemNumber?._on('blur', this.hideAutocomplete.bind(this));
    document._on('click', this.hideSuggestions.bind(this));
    $coaBtnSubmit?._on('click', this.handleCoaFormSubmit.bind(this));
    $modalCoo?._on('submit', this.submitCoo.bind(this));
    $modalCooRequest?._on('submit', this.submitCooRequest.bind(this));
    this.dom.$requiredFields?._on('change', this.enableDisableBtn.bind(this));
    $(document).ready(() => {
      $modalCooRequestBtnSubmit.disabled = true;
      $('.generic-modal__overlay').removeAttr('data-generic-modal-close');
    });
  } //addListeners

  init() {
    const { $el } = this.dom;

    const $genericModal = $el.closest('.generic-modal');
    if ($genericModal) {
      this.modalId = $genericModal.getAttribute('id') || null;
    }

  } //init

  modalInit() {
    const { $modalCoo, $modalCooRequest, $modalSuccess } = this.dom;

    if (this.modalId) {
      MicroModal.init({
        onClose: modal => {
          this.resetCoaForm();
          this.resetCooForm();
          this.resetCooRequestForm();

          setTimeout(() => {
            try {
              $modalCoo.style.display = 'block';
              $modalCooRequest.style.display = 'none';
              $modalSuccess.style.display = 'none';
            } catch (error) {
              return;
            }
          }, 500);
        },
        openTrigger: 'data-generic-modal-open',
        closeTrigger: 'data-generic-modal-close',
        openClass: 'generic-modal--open',
        disableScroll: true,
        disableFocus: true,
        awaitOpenAnimation: true,
        awaitCloseAnimation: true
      });
    }
  } //modalInit

  pristineInit() {
    const { $coaForm, $modalCooForm, $modalCooRequestForm } = this.dom;

    if ($coaForm) {
      this.pristineCoa = new Pristine($coaForm, PRISTINE_SETTINGS);
    }

    if ($modalCooForm) {
      this.pristineCoo = new Pristine($modalCooForm, PRISTINE_SETTINGS);
    }

    if ($modalCooRequestForm) {
      this.pristineCooRequest = new Pristine(
        $modalCooRequestForm,
        PRISTINE_SETTINGS
      );
    }
  } //pristineInit

  resetCoaForm() {
    const { $coaForm, $coaBtnSubmit } = this.dom;
    try {
      $coaForm.reset();
      $coaBtnSubmit.disabled = false;
      this.pristineCoa.reset();
    } catch (error) {
      return;
    }
  } //resetCooForm

  resetCooForm() {
    const { $modalCooForm, $modalCooBtnSubmit } = this.dom;
    try {
      $modalCooForm.reset();
      $modalCooBtnSubmit.disabled = false;
      this.pristineCoo.reset();
    } catch (error) {
      return;
    }
  } //resetCooForm

  resetCooRequestForm() {
    const { $modalCooRequestForm, $modalCooRequestBtnSubmit } = this.dom;
    try {
      $modalCooRequestForm.reset();
      // $modalCooRequestBtnSubmit.disabled = false;
      this.pristineCooRequest.reset();
    } catch (error) {
      return;
    }
  } //resetCooRequestForm

  enableDisableBtn(ele) {
    const parentForm = $(ele.target).closest('form').find('.btn');
    const isDisabled = false;
    if (!isDisabled){
      const RecaptchField = document.getElementById('recaptcha_field-caa');
      if (RecaptchField){
        RecaptchField.value = window.grecaptcha.getResponse();
      }
    }

    parentForm.removeAttr('disabled');
  } //enableDisableBtn

  tooltipInit() {
    tippy(this.tooltipTriggerClass, {
      content(reference) {
        const id = reference.getAttribute('data-template');
        const template = document.getElementById(id);
        return template?.innerHTML || null;
      },
      allowHTML: true,
      theme: 'light',
      arrow: true,
      trigger: 'click',
      placement: 'bottom',
      maxWidth: 330
    });
  } //tooltipInit

  submitCoo(e) {
    e.preventDefault();
    const {
      $modalCoo,
      $modalCooForm,
      $modalCooBtnSubmit,
      $modalCooRequest,
      $modalCooRequestFormLotNumber
    } = this.dom;
    const valid = this.pristineCoo.validate();

    if (valid) {
      $modalCooBtnSubmit.disabled = true;

      const endpoint = $modalCooForm.getAttribute('action') || null;
      const formData = serialize($modalCooForm, SERIALIZE_SETTINGS);
      const finalEndpoint = `${endpoint}${formData?.lot_number}`;

      axios({
        method: 'get',
        url: finalEndpoint,
        headers: {
          'content-type': 'application/json'
        }
      }).then(response => {
        const { success, body } = response.data;

        if (success) {
          const path = body?.path;
          window.open(path, '_blank');
        } else {
          $modalCooRequestFormLotNumber.value = formData?.lot_number;

          this.changeView({
            currentView: $modalCoo,
            newView: $modalCooRequest
          });
        }

        this.resetCooForm();
      });
    }
  } //submitCoo

  submitCooRequest(e) {
    e.preventDefault();
    const {
      $modalCooRequest,
      $modalCooRequestForm,
      $modalCooRequestBtnSubmit,
      $modalSuccess,
      $modalMessage
    } = this.dom;
    const valid = this.pristineCooRequest.validate();

    if (valid) {
      $modalCooRequestBtnSubmit.disabled = true;

      const endpoint = $modalCooRequestForm.getAttribute('action') || null;
      const formData = serialize($modalCooRequestForm, SERIALIZE_SETTINGS);

      axios({
        method: 'post',
        url: endpoint,
        data: formData,
        headers: {
          'content-type': 'application/json'
        }
      }).then(response => {
        const { success, message } = response.data;

        if (success) {
          $modalMessage.style.display = 'none';
          console.log('success coo');
          this.changeView({
            currentView: $modalCooRequest,
            newView: $modalSuccess
          });
        } else {
          $modalCooRequestBtnSubmit.disabled = false;
          $modalMessage.innerHTML = message;
          $modalMessage.style.display = 'block';
        }

        this.resetCooRequestForm();
      });
    }
  } //submitCooRequest

  changeView({ currentView = null, newView = null }) {
    if (currentView && newView) {
      currentView.style.display = 'none';
      newView.style.display = 'block';
    }
  } //changeView

  setAutocomplete(e) {
    const {
      $coaItemNumber,
      $coaItemNumberAutocomplete,
      $coaItemNumberAutocompleteList,
      $coaBtnSubmit
    } = this.dom;
    const autocompleteUrl = `${$coaItemNumber.dataset.autocompleteUrl}?atcc_number=${$coaItemNumber.value}`;
    if ($coaItemNumber.value.length > 2) {
      axios({
        method: 'get',
        url: autocompleteUrl,
        headers: {
          'content-type': 'application/json'
        }
      }).then(response => {
        const { success, body } = response.data;
        let options = '';
        if (success) {
          body.autocomplete.forEach(item => {
            options += `<li data-value=${item.value}>${item.autocompleteText}</li>`;
          });
        }
        if (options.length) {
          $coaItemNumberAutocompleteList.innerHTML = options;
          $coaItemNumberAutocomplete.classList.remove('no-results');
          $coaItemNumberAutocomplete.classList.add('active');
          const items = $coaItemNumberAutocomplete._$$('li');
          items.forEach(item => {
            item._on('click', this.handleOptionClick.bind(this));
          });
          $coaBtnSubmit.disabled = false;
        } else {
          $coaItemNumberAutocomplete.classList.remove('active');
          $coaItemNumberAutocomplete.classList.add('no-results');
          $coaItemNumber.value = '';
          $coaBtnSubmit.disabled = true;
        }
      });
    } else {
      $coaItemNumberAutocomplete.classList.remove('active');
      $coaItemNumberAutocomplete.classList.remove('no-results');
      $coaBtnSubmit.disabled = true;
    }
  } //setAutocomplete

  hideAutocomplete(e) {
    const { $coaItemNumberAutocomplete } = this.dom;
    $coaItemNumberAutocomplete.classList.remove('no-results');
  } //hideAutocomplete

  handleOptionClick(e) {
    const { $coaItemNumber, $coaItemNumberAutocomplete } = this.dom;
    $coaItemNumber.value = e.currentTarget.dataset.value;
    $coaItemNumberAutocomplete.classList.remove('active');
  } //handleOptionClick

  hideSuggestions() {
    const { $coaItemNumberAutocomplete } = this.dom;
    //$coaItemNumberAutocomplete.classList.remove('active');
    // $coaItemNumberAutocomplete.classList.remove('no-results');
  }

  openModal(e) {
    if (this.modalId) {
      MicroModal.show(this.modalId, {
        onClose: modal => {
          this.resetCoaForm();
          this.resetCooRequestForm();
        },
        openTrigger: 'data-generic-modal-open',
        closeTrigger: 'data-generic-modal-close',
        openClass: 'generic-modal--open',
        disableScroll: true,
        disableFocus: true,
        awaitOpenAnimation: true,
        awaitCloseAnimation: true
      });
    }
  } //openModal

  async handleCoaFormSubmit(e) {
    e.preventDefault();
    const {
      $coaForm,
      $coaBtnSubmit,
      $modalCooRequestFormLotNumber,
      $coaRequestCatalogNumber
    } = this.dom;
    const valid = this.pristineCoa.validate();

    if (valid) {
      $coaBtnSubmit.disabled = true;

      const endpoint = $coaForm.getAttribute('action') || null;
      const formData = serialize($coaForm, SERIALIZE_SETTINGS);
      const finalEndpoint = `${endpoint}?atcc_number=${formData?.atcc_number}&lot_number=${formData?.lot_number}`;
      const temp_lot_num = $modalCooRequestFormLotNumber.value;
      const temp_atcc_num = $coaRequestCatalogNumber.value;
      const modalElement = document.getElementById('modal-certificate-analysis');
      const requestDescription = document.querySelector('.modal-certificate-analysis__coo-request .modal-certificate-analysis__description');
      const coaDetailsEndpoint = document.querySelector('.modal-certificate-analysis .modal-certificate-analysis__container').getAttribute('data-endpoint');

      try {
        const response = await axios({
          method: 'get',
          url: finalEndpoint,
          headers: {
            'content-type': 'application/json'
          }
        });

        const { success, body } = response.data;
        if (success) {
          const path = body?.path;
          window.open(path, '_blank');
        } else {
          console.log('success:false');

          const coaDataResponse = await axios.get(`${coaDetailsEndpoint}?Atcc_Number=${formData?.atcc_number}`);
          const coaData = coaDataResponse.data;

          if (coaData.RequestModalDescription) {
            requestDescription.innerHTML = coaData.RequestModalDescription;
          }

          $modalCooRequestFormLotNumber.value = formData?.lot_number || temp_lot_num;
          $coaRequestCatalogNumber.value = formData?.atcc_number || temp_atcc_num;
          this.openModal();
          setTimeout(() => {
            this.dom.$modalCoo.style.display = 'none';
            this.dom.$modalCooRequest.style.display = 'block';
            this.dom.$modalSuccess.style.display = 'none';
          }, 0);
        }
      } catch (error) {
        console.error('Error handling COA form submission:', error);
        $coaBtnSubmit.disabled = false;
      }
    }
  }

}

export default Module;
